import {FileDescription, SignatureDataEntry} from '../files/files.model';

export type EmployeeDocument = FileDescription;

export interface StatusVM {
  id: number;
  select: string;
  name: string;
}

export enum TemplateAvailability {
  HR_PRO = 'HR_PRO',
  EMPLOYEE = 'EMPLOYEE',
  MANAGER = 'MANAGER'
}

export interface Template {
  name: string;
  cliRegId: number;
  transId: string;
  engine: 'REPORT' | 'SYNCFUSION';
  type?: string;
  locale?: string;
  folder?: string;
  arguments?: TemplateArgument[];
}

export interface TemplateArgument {
  arg1?: string;
  arg2?: string;
  argumentName?: string;
  defaultValue?: string;
  displayOrder?: number;
  hidden?: boolean;
  isHidden?: boolean;
  isReadOnly?: boolean;
  isRequired?: boolean;
  metadatas?: any;
  nbColumns?: number;
  nbRows?: number;
  readOnly?: boolean;
  regExp?: string;
  required?: boolean;
  transId?: string;
  type?:
    | 'TEXT'
    | 'LABEL'
    | 'DATE'
    | 'MONTH'
    | 'INTEGER'
    | 'PERCENTAGE'
    | 'BOOLEAN'
    | 'ENTITY'
    | 'DECIMAL'
    | 'LIST'
    | 'TREE'
    | 'ID';
  validation?: string;
}

export interface Document {
  arguments: any[];
  cliRegId: number;
  contractId: string;
  engine: string;
  locale: string;
  name: string;
  value?: string;
  signatureData?: SignatureDataEntry[];
}

export enum DocumentsOfferingNames {
  NO_OFFERING = 'NO_OFFERING',
  BASIC = 'BASIC',
  ADVANCED = 'ADVANCED',
  UNLIMITED = 'UNLIMITED'
}

export interface DocumentsOffering {
  value: DocumentsOfferingNames;
  maxDocuments: number;
  maxUploadSize: number;
}
